import React from "react";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Divider from "@material-ui/core/Divider";
import Radio from "@material-ui/core/Radio";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import "assets/scss/carrito.scss";

/**
 * Componente para mostrar y seleccionar el método de envío
 * @param {Array} costosEnvio - Lista de opciones de envío disponibles
 * @param {Object} paqueteriaSeleccionada - Paquetería seleccionada
 * @param {Function} onSelect - Callback cuando se selecciona una opción
 * @param {boolean} loading - Si está cargando
 * @param {string} error - Mensaje de error si existe
 * @param {Function} formatPrice - Función para formatear el precio
 * @param {boolean} tieneDireccion - Si hay dirección seleccionada
 */
const ShippingMethod = ({
	costosEnvio,
	paqueteriaSeleccionada,
	onSelect,
	loading,
	error,
	formatPrice,
	tieneDireccion,
}) => {
	if (!tieneDireccion) {
		return (
			<Card className="carrito-card">
				<CardBody className="carrito-card-body">
					<div className="carrito-card-title-section">
						<h4 className="carrito-card-title">Método de envío</h4>
						<Divider />
					</div>
					Ingrese una dirección de envío
				</CardBody>
			</Card>
		);
	}

	// Mostrar skeleton cuando está cargando
	if (loading) {
		return (
			<Card className="carrito-card">
				<CardBody className="carrito-card-body">
					<div className="carrito-card-title-section">
						<h4 className="carrito-card-title">Método de envío</h4>
						<Divider />
					</div>
					<GridContainer>
						<GridItem xs={12}>
							<div className="carrito-skeleton-loader">
								<TableContainer>
									<Table>
										<TableHead>
											<TableRow>
												<TableCell
													style={{
														fontWeight: "bold",
														width: "50px",
													}}
												>
													Seleccionar
												</TableCell>
												<TableCell style={{ fontWeight: "bold" }}>
													PAQUETERÍA
												</TableCell>
												<TableCell style={{ fontWeight: "bold" }}>
													SERVICIO
												</TableCell>
												<TableCell style={{ fontWeight: "bold" }}>
													DÍAS DE ENTREGA
												</TableCell>
												<TableCell style={{ fontWeight: "bold" }}>
													PRECIO
												</TableCell>
											</TableRow>
										</TableHead>
										<TableBody>
											{[1, 2, 3].map((index) => (
												<TableRow key={index}>
													<TableCell style={{ padding: "8px" }}>
														<div
															className="skeleton-line"
															style={{
																width: "24px",
																height: "24px",
																borderRadius: "50%",
																margin: "0 auto",
															}}
														/>
													</TableCell>
													<TableCell>
														<div
															className="skeleton-line"
															style={{
																width: "80%",
																height: "16px",
															}}
														/>
													</TableCell>
													<TableCell>
														<div
															className="skeleton-line"
															style={{
																width: "70%",
																height: "16px",
															}}
														/>
													</TableCell>
													<TableCell>
														<div
															className="skeleton-line"
															style={{
																width: "50px",
																height: "16px",
															}}
														/>
													</TableCell>
													<TableCell>
														<div
															className="skeleton-line"
															style={{
																width: "80px",
																height: "16px",
															}}
														/>
													</TableCell>
												</TableRow>
											))}
										</TableBody>
									</Table>
								</TableContainer>
							</div>
						</GridItem>
					</GridContainer>
				</CardBody>
			</Card>
		);
	}

	return (
		<Card className="carrito-card">
			<CardBody className="carrito-card-body">
				<div className="carrito-card-title-section">
					<h4 className="carrito-card-title">Método de envío</h4>
					<Divider />
				</div>
				<GridContainer>
					<GridItem xs={12}>
						<TableContainer>
							<Table>
								<TableHead>
									<TableRow>
										<TableCell
											style={{
												fontWeight: "bold",
												width: "50px",
											}}
										>
											Seleccionar
										</TableCell>
										<TableCell style={{ fontWeight: "bold" }}>
											PAQUETERÍA
										</TableCell>
										<TableCell style={{ fontWeight: "bold" }}>
											SERVICIO
										</TableCell>
										<TableCell style={{ fontWeight: "bold" }}>
											DÍAS DE ENTREGA
										</TableCell>
										<TableCell style={{ fontWeight: "bold" }}>PRECIO</TableCell>
									</TableRow>
								</TableHead>
								<TableBody>
									{costosEnvio.length > 0 ? (
										<>
											{costosEnvio.map((opcion, index) => {
												const isSelected =
													paqueteriaSeleccionada &&
													JSON.stringify(paqueteriaSeleccionada) ===
														JSON.stringify(opcion);

												return (
													<TableRow
														key={index}
														hover
														style={{ cursor: "pointer" }}
														onClick={() => onSelect(opcion)}
													>
														<TableCell style={{ padding: "8px" }}>
															<Radio
																checked={isSelected}
																onChange={() => onSelect(opcion)}
																onClick={(e) => {
																	e.stopPropagation();
																}}
															/>
														</TableCell>
														<TableCell>
															{opcion.Paqueteria.toUpperCase()}
														</TableCell>
														<TableCell>
															{opcion.Servicio.toUpperCase()}
														</TableCell>
														<TableCell>{opcion.Dias} días</TableCell>
														<TableCell>{formatPrice(opcion.Precio)}</TableCell>
													</TableRow>
												);
											})}
										</>
									) : (
										<TableRow>
											<TableCell
												colSpan={5}
												style={{
													textAlign: "center",
													padding: "20px",
												}}
											>
												{error ? (
													<div className="error-message">{error}</div>
												) : (
													"No hay opciones de envío disponibles"
												)}
											</TableCell>
										</TableRow>
									)}
								</TableBody>
							</Table>
						</TableContainer>
					</GridItem>
				</GridContainer>
			</CardBody>
		</Card>
	);
};

export default ShippingMethod;
